/* tslint:disable */
/* eslint-disable */
/**
 * Commerce Webservices
 * Manages all of the common commerce functionality, and also includes customizations from installed AddOns. The implementing extension is called commercewebservices.
 *
 * The version of the OpenAPI document: 2.2.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * Representation of a Stock
 * @export
 * @interface Stock
 */
export interface Stock {
    /**
     * Status of stock level
     * @type {string}
     * @memberof Stock
     */
    stockLevelStatus?: string;
    /**
     * Stock level expressed as number
     * @type {number}
     * @memberof Stock
     */
    stockLevel?: number;
    /**
     * Indicate whether Stock level value is rounded
     * @type {boolean}
     * @memberof Stock
     */
    isValueRounded?: boolean;
}

/**
 * Check if a given object implements the Stock interface.
 */
export function instanceOfStock(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function StockFromJSON(json: any): Stock {
    return StockFromJSONTyped(json, false);
}

export function StockFromJSONTyped(json: any, ignoreDiscriminator: boolean): Stock {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'stockLevelStatus': !exists(json, 'stockLevelStatus') ? undefined : json['stockLevelStatus'],
        'stockLevel': !exists(json, 'stockLevel') ? undefined : json['stockLevel'],
        'isValueRounded': !exists(json, 'isValueRounded') ? undefined : json['isValueRounded'],
    };
}

export function StockToJSON(value?: Stock | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'stockLevelStatus': value.stockLevelStatus,
        'stockLevel': value.stockLevel,
        'isValueRounded': value.isValueRounded,
    };
}

